jQuery(() => {
    const html = $('html');
    const button = $('#menu-responsive-button');
    const buttonUser = $('#page-header-user-dropdown-responsive');
    const container = $('#container-menu-responsive');
    const solde = $('.solde-licence');
    const buttonIcon = $('#menu-responsive-button i')

    button.on('click', () => {
        if (!button.hasClass('active')) {
            button.addClass('active');
            container.addClass('show')
            solde.addClass('d-none')
            buttonUser.addClass('d-none')
            buttonIcon.addClass('xmark')
            html.addClass('overflow-hidden')
            buttonIcon.removeClass('hamb')
        } else {
            buttonIcon.addClass('hamb')
            button.removeClass('active');
            container.removeClass('show')
            solde.removeClass('d-none')
            buttonUser.removeClass('d-none')
            buttonIcon.removeClass('xmark')
            html.removeClass('overflow-hidden')
        }
    })

    $(window).on('load', function () {
        $('.custom_filtre').hide();

        $('.affiche_filtre').on('click', function () {
            $('.custom_filtre').toggle('hide');
        });

    })

});
